import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Validations from './validations';

Vue.component('validation-provider', Validations);
//Vue.use(VeeValidate);
import VueSweetalert2 from 'vue-sweetalert2'
import moment from 'moment';


Vue.config.productionTip = false

// Third Party Libraries
window.axios = require('axios');

//We are going to define gtag here to make it global.
// Then we dont need to keep defining it everywhere
// This is used for Google Analytics
// and Google Tag Manager
window.dataLayer = window.dataLayer || [];
window.gtag = function () {
  window.dataLayer.push(arguments);
};

Vue.use(require('vue-moment'));
Vue.use(VueSweetalert2);

Vue.filter('moment', (value, format) => {
  return moment(value).format(format);
})


const courseId = new URLSearchParams(window.location.search).get('c');

if (courseId) {
  axios.get(process.env.VUE_APP_API_URL + 'api/course/' + courseId).then(({ data }) => {
    if (data.success && data.course.type.id === 20) {
      window.location.href = 'https://checkout.intelvio.com/?c=' + courseId;
    } else {
      new Vue({ router, store, render: h => h(App) }).$mount('#app');
    }
  }).catch(() => {
    new Vue({ router, store, render: h => h(App) }).$mount('#app');
  });
} else {
  new Vue({ router, store, render: h => h(App) }).$mount('#app');
}
